(function () {
    'use strict';

    angular
        .module('Lavpop-store.directives')
        .directive('orderUnit', OrderUnit)

    /** @ngInject */
    function OrderUnit(PATHS) {
        function OrderUnitController() {
            const vm = this;
        }

        return {
            bindToController: true,
            controller: OrderUnitController,
            controllerAs: 'vm',
            restrict: 'AE',
            templateUrl: `${PATHS.PHYSICAL}/directives/order-unit/order-unit.html`,
            scope: {
                unit: '='
            }
        }
    }
}());